<template>
  <nav 
    :class="{ mobile: isMobile }"
    :style="{ 'background' : fairConfig.FC_HEADFOOT_COLOR }"
  >
    <div class="left">
      <div v-if="isMobile">
        <a-button
          type="ghost"
          class="mobileOpenMenuBtn"
          @click="toggleCollapsed"
        >
          <a-icon type="menu" />
        </a-button>
        <a-drawer
          title="Menu"
          class="mobileMenuDrawer"
          placement="left"
          width="80%"
          :visible="mobileMenuVisible"
          @close="closeMobileMenu"
          >
          <search-bar
        :mobileSearchBar="mobileSearchBar"
        :isMobile="isMobile"
        @toggle-search-bar="toggleSearchBar"
      ></search-bar>
          
         <!--  <a-input-search
            class="mobileSearch"
            v-model="searchQuery"
            placeholder="Search"
          /> -->
          <router-link to="/"><a @click="setActive">{{ fairConfig.FC_HOME_NAME }}</a></router-link>
          <router-link
            to="/info-booth"
            v-if="parseInt(fairConfig.FC_INFO) !== 0 && checkPermissions(['info_view'])"
            ><a @click="setActive">{{ fairConfig.FC_INFO_NAME }}</a></router-link
          >
          <router-link
            to="/list-of-attendees"
            v-if="checkPermissions(['list_of_attendees_view']) && parseInt(fairConfig.FC_LISTUSERS) !== 0"
            ><a @click="setActive">{{ fairConfig.FC_ALL_USERS_NAME }}</a></router-link
          >
          <a-dropdown v-if="checkPermissions(['expo_view']) && expoFloors.length != 0" :trigger="['click']">
            <a :class="navExpo === true ? 'active' : ''">
              {{ fairConfig.FC_EXPO_NAME }}<a-icon
                type="down"
                style="padding-left:10px;font-size:16px;vertical-align: -0.135em;"
              />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-for="(item, i) in expoFloors" :key="i">
                <router-link :to="'/floor/' + item.loc_id"
                  ><a @click="setActiveExpo" class="mobile-nav-dropdown"
                    >{{ item.name }}
                  </a></router-link
                >
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-dropdown v-if="checkPermissions(['conf_view']) && conferences.length != 0" :trigger="['click']">
            <a :class="navConference == true ? 'active' : ''">
              {{ fairConfig.FC_CONFERENCE_NAME }}<a-icon
                type="down"
                style="padding-left:10px;font-size:16px;vertical-align: -0.135em;"
              />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-for="(item, i) in conferences" :key="i">
                <router-link :to="'/live/' + item.loc_id"
                  ><a @click="setActiveConference" class="mobile-nav-dropdown"
                    >{{ item.name }}
                  </a></router-link
                >
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <router-link v-if="checkPermissions(['agenda_view'])" to="/agenda"
            ><a @click="setActive">{{ fairConfig.FC_AGENDA_NAME }}</a></router-link
          >
          <router-link v-if="checkPermissions(['agenda_view'])" to="/agenda?activeSessions"><a @click="setActive" class="active-sessions purple"><span class="active-sessions-tab" />{{ fairConfig.FC_ACTIVE_SESSIONS_NAME }}</a></router-link>
          <template v-if="checkPermissions(['side_menu_items_view'])">
            <a
              :href="item.smi_link"
              v-tooltip="item.smi_name"
              v-for="(item, i) in additionalElements"
              :key="i"
              target="_blank"
              @click="setActive"
            >
              {{ item.smi_name }}
            </a>
          </template>
        </a-drawer>
      </div>
      <div class="logo-wrap" v-if="showLogo">
        <router-link :to="isCurrentPathAnAuthPath && !isPublic ? '' : '/'">
          <!-- <h1 class="nav-heading">A Demo Event</h1> -->
          <!-- <img src="/api/logo" alt="logo" /> -->
        </router-link>
      </div>
    </div>
    <div class="middle">
      <!-- <div class="navigation-links" v-if="!searchOpen && !isLoggedIn">
        <a href="/">Home</a>
      </div> -->
      <div
        class="navigation-links"
        v-if="!searchOpen && !isMobile && (isLoggedIn || isPublic)"
      >
        <router-link to="/"><a>{{ fairConfig.FC_HOME_NAME }}</a></router-link>
        <router-link to="/info-booth" v-if="parseInt(fairConfig.FC_INFO) !== 0 && checkPermissions(['info_view'])"
          ><a>{{ fairConfig.FC_INFO_NAME }}</a></router-link
        >
        <router-link
          v-if="checkPermissions(['list_of_attendees_view']) && parseInt(fairConfig.FC_LISTUSERS) !== 0"
          to="/list-of-attendees"
          ><a>{{ fairConfig.FC_ALL_USERS_NAME }}</a></router-link
        >
        <a-dropdown v-if="checkPermissions(['expo_view']) && expoFloors.length != 0">
          <a class="ant-dropdown-link">
            {{ fairConfig.FC_EXPO_NAME }}<a-icon
              type="down"
              style="padding-left:10px;font-size:16px;vertical-align: -0.135em;"
            />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-for="(item, i) in expoFloors" :key="i">
              <router-link :to="'/floor/' + item.loc_id"
                ><a>{{ item.name }} </a></router-link
              >
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown v-if="checkPermissions(['conf_view']) && conferences.length != 0">
          <a class="ant-dropdown-link">
            {{ fairConfig.FC_CONFERENCE_NAME }}<a-icon
              type="down"
              style="padding-left:10px;font-size:16px;vertical-align: -0.135em;"
            />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-for="(item, i) in conferences" :key="i">
              <router-link :to="'/live/' + item.loc_id"
                ><a>{{ item.name }} </a></router-link
              >
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <router-link v-if="checkPermissions(['agenda_view'])" to="/agenda"><a>{{ fairConfig.FC_AGENDA_NAME }}</a></router-link>
        <router-link v-if="checkPermissions(['agenda_view'])" to="/agenda?activeSessions"><a @click="setActive" class="active-sessions"><span class="active-sessions-tab" />{{ fairConfig.FC_ACTIVE_SESSIONS_NAME }}</a></router-link>
        <template v-if="checkPermissions(['side_menu_items_view'])">
          <a
            :href="item.smi_link"
            v-tooltip="item.smi_name"
            v-for="(item, i) in additionalElements"
            :key="i"
            target="_blank"
          >
            {{ item.smi_name }}
          </a>
        </template>
      </div>
      <div class="searchBox" v-if="searchOpen">
        <search-bar
        @closeSearch="openSearchBox"
        v-if="!isMobile"
        style="display:inline-block;margin-right:0;margin-left:20px;width:100%"
      ></search-bar>
      <!-- <search-bar
        v-else
        :mobileSearchBar="mobileSearchBar"
        :isMobile="isMobile"
        @toggle-search-bar="toggleSearchBar"
      ></search-bar> -->
        <!-- <a-input
          placeholder="I am searching here..."
          style="width: 100%;"
          id="searchBox"
          v-model="searchQuery"
        >
          <a-icon slot="suffix" type="close" @click="openSearchBox" />
          <a-button slot="addonAfter" icon="search"> </a-button>
        </a-input> -->
      </div>
      <a-button
        icon="search"
        class="search-icon"
        @click="openSearchBox"
        v-if="!searchOpen && !isMobile && (isLoggedIn || isPublic)"
      ></a-button>
      <!-- <search-bar
        v-if="!isMobile"
        style="display:inline-block;margin-right:0;margin-left:20px"
      ></search-bar>
      <search-bar
        v-else
        :mobileSearchBar="mobileSearchBar"
        :isMobile="isMobile"
        @toggle-search-bar="toggleSearchBar"
      ></search-bar> -->
    </div>
    <div class="right" v-if="!isLoggedIn">
      <!-- <search-bar v-if="!isMobile && isPublic"></search-bar>
      <search-bar
        v-if="isMobile && isPublic"
        :mobileSearchBar="mobileSearchBar"
        :isMobile="isMobile"
        @toggle-search-bar="toggleSearchBar"
      ></search-bar> -->
      <!-- <div class="icon" :class="{ selected: chatOpened }" @click="handleChat">
        <div
          class="new-messages-notification chat-notific"
          v-if="this.newMessages"
        ></div>
        <img
          :src="$images.mail"
          :class="{ 'icon-shake': newMessages }"
          alt="messages"
        />
      </div> -->
      <!-- <div class="icon" v-if="!isMobile && isPublic">
        <div
          class="new-messages-notification"
          v-if="this.notifications.length > 0"
        ></div>
        <a
          @mouseenter="handleOpen({ notifications: true })"
          @mouseleave="handleOpen({ notifications: false })"
        >
          <img :src="$images.notifications" alt="messages" />
        </a>
        <div
          class="menu-wrap"
          v-if="openMenu.notifications"
          @mouseenter="handleOpen({ notifications: true })"
          @mouseleave="handleOpen({ notifications: false })"
        >
          <div class="triangle"></div>
          <div class="items-container notifications-drawer">
            <div class="popup-menu-heading">
              {{ $t("newblock.nav.notific") }}
            </div>
            <router-link
              v-for="(notification, index) in notifications"
              class="items notification-item"
              :key="index"
              :to="notification.loc_id ? '/live/' + notification.loc_id : ''"
            >
              <span>
                <strong>{{ $t("newblock.nav.curLecture") }}:</strong>
                {{ notification.agn_name }}
              </span>
            </router-link>
          </div>
        </div>
      </div> -->
      <!-- <router-link
        v-if="!isPublic || parseInt(fairConfig.FC_LOGREG)"
        class="button-round"
        :to="route"
      >
        {{ $t("nav." + route.substring(1)) }}
        <img :src="$images.arrowRight" alt="arrow-right" />
      </router-link> -->
      <router-link
        v-if="!isPublic || parseInt(fairConfig.FC_LOGREG)"
        :to="route"
        ><a-button type="link" href="/login" class="loginBtn">
          {{ $t("nav.login") }}
        </a-button>
      </router-link>
      <router-link
        v-if="!isPublic || parseInt(fairConfig.FC_LOGREG)"
        to="/register"
      >
        <a-button type="primary" class="registerBtn">
          {{ $t("nav.register") }}
        </a-button>
      </router-link>
    </div>
    <div class="right" v-else>
      <div class="icon-wrap" v-if="incomingCall">
        <div class="icon" v-if="!showCall">
          <img
            :src="$images.call"
            alt="phone"
            class="call"
            @click="$emit('show-call')"
          />
          <transition tag="div" appear name="fade-down">
            <div
              class="new-call-wrap"
              :class="{ mobile: isMobile }"
              @click="$emit('show-call')"
            >
              {{ $t("call.new-call") }}
              <span
                class="material-icons"
                @click.stop="$emit('mute-chime', !muted)"
              >
                {{ muted ? "volume_off" : "volume_up" }}
              </span>
            </div>
          </transition>
        </div>
      </div>
      <div class="icon-wrap">
        <div v-if="checkPermissions(['chat_view'])" class="icon" :class="{ selected: chatOpened }" @click="handleChat">
          <div
            class="new-messages-notification chat-notific"
            v-if="this.newMessages"
          ></div>
          <img
            :src="$images.mailWhite"
            :class="{ 'icon-shake': newMessages }"
            alt="messages"
          />
        </div>
        <div class="icon">
          <div
            class="new-messages-notification"
            v-if="this.notifications.length > 0"
          ></div>
          <a
          @click="handleOpen({ notifications: !openMenu.notifications })"
          >
            <img :src="$images.notificationsWhite" alt="messages" />
          </a>
          <div
            class="menu-wrap"
            v-if="openMenu.notifications"
           @click="handleOpen({ notifications: !openMenu.notifications })"
          >
            <div class="triangle"></div>
            <div class="items-container notifications-drawer">
              <!-- <div class="popup-menu-heading">
                {{ $t("newblock.nav.notific") }}
              </div> -->
              <div v-for="(notification, index) in notifications" :key="index" @click="handleNotificClick(notification)">
                <a-row type="flex" align="middle" class="items notification-item" :class="{'no-hairline': index === notifications.length - 1}" v-if="notification.type === 'agenda'">
                  <a-col :span="20">
                    <p class="notification-title">
                    <b>{{ $t("newblock.nav.curLecture") }}: </b>{{ notification.data.agn_name }}
                    </p>
                  </a-col>
                  <a-col :span="4" v-if="notification.data.agt_id === 2">
                  <router-link :to="notification.data.loc_id ? '/live/' + notification.data.loc_id : '/agenda?activeSessions'">
                  <a-button type="primary" class="notification-join">{{ $t("newAgenda.join") }}</a-button>
                  </router-link>
                  </a-col>
                  <a-col :span="4" v-else>
                  <router-link  to="/agenda?activeSessions">
                  <a-button type="primary" class="notification-join">{{ $t("newAgenda.join") }}</a-button>
                  </router-link>
                  </a-col>
                </a-row>

                <a-row type="flex" align="middle" class="items notification-item" :class="{'no-hairline': index === notifications.length - 1}" v-if="notification.type === 'text'">
                  <a-col :span="20">
                    <p class="notification-title">
                    {{ notification.data }}
                    </p>
                  </a-col>
                </a-row>

                <a-row type="flex" align="middle" class="items notification-item" :class="{'no-hairline': index === notifications.length - 1}" v-if="notification.type === 'badge'">
                  <a-col :span="20">
                    <p class="notification-title">
                    {{ notification.data }}
                    </p>
                  </a-col>
                </a-row>
              </div>

              <a-row type="flex" align="middle" v-if="notifications.length===0" class="items notification-item">
                <a-col :span="24">
                  <p class="notification-title">{{$t('nav.noNotifications')}}</p>
                </a-col>
              </a-row>
            </div>
          </div>
        </div>
      </div>
      <div class="profile-wrap">
        <a @click="handleShowProfile">
          <div class="avatar-wrap">
            <img
              class="frame"
              :src="
                imageBaseUrl +
                'api/users/' +
                'pictureframe?rol_id=' +
                rol_id +
                '&type=circle' +
                '&sid=' +
                sid
              "
              alt=""
            />
            <img :src="avatar" alt="avatar" id="show-profile" />
          </div>
          <h2 class="member-name">
            {{ firstName }} {{ lastName }}
            <a-icon type="down" v-if="!isMobile" />
          </h2>
        </a>
        <div class="menu-wrap" v-if="showProfile">
          <div class="triangle"></div>
          <div class="items-container login-container">
            <router-link class="items" to="/profile" @click="closeProfile">{{
              $t("newblock.nav.profile")
            }}</router-link>
            <a class="items" @click="EventBus.$emit('logout')">{{
              $t("newblock.nav.logOut")
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api";
import axios from "axios";
import SearchBar from "./SearchBar";
export default {
  props: {
    isMobile: {
      type: Boolean,
    },
    avatar: String,
    firstName: String,
    lastName: String,
    newMessages: Number,
    notifications: Array,
    showCall: Boolean,
    incomingCall: Boolean,
    muted: Boolean,
  },
   components: {
    SearchBar,
  },
  data() {
    return {
      openMenu: {
        main: false,
        drawer: false,
        notifications: false,
      },
      showProfile: false,
      mobileSearchBar: false,
      usersResult: [],
      agendaResult: [],
      boothsResult: [],
      showResults: false,
      searchTimeoutId: null,
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
      searchOpen: false,
      searchQuery: "",
      expoFloors: [],
      conferences: [],
      additionalElements: [],
      mobileMenuVisible: false,
      navConference: false,
      navExpo: false,
      oldNotifications: [],
    };
  },
  watch: {
    notifications: function (val, oldVal) {
      for (let i = 0; i < val.length; i++) {
        const element = val[i];
        const oldElement = oldVal[i] ? oldVal[i] : {};
        if(element.agn_lecturer != oldElement.agn_lecturer){
          this.openMenu.notifications = true;
        }
      }

    },
  },
  mounted() {
    this.init();
  },
  computed: {
    sid() {
      return localStorage.getItem("sid");
    },
    rol_id() {
      return this.rol_id;
    },
    route() {
      return this.$route.path.endsWith("login") ? "/register" : "/login";
    },
    showLogo() {
      return !this.isMobile || !this.mobileSearchBar;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isCurrentPathAnAuthPath() {
      return ["/login", "/register"].includes(this.$route.path);
    },
    ...mapState(["chatOpened", "fairConfig",'rol_id']),
  },
  methods: {
    async init() {
      this.getFloors();
      this.getConferences();
      this.getAdditionalItemsForSidebar();
    },
    handleNotificClick(notific) {
      if (notific.type === 'badge') {
        this.$router.push('/profile');
        return
      }
    },
    async getItemImageUrl(item) {
      let img = await axios.get(
        process.env.VUE_APP_API_URL +
          `/sidemenuitems/${item.smi_id}?sid=${this.sid()}`
      );
      return img.data;
    },
    async getAdditionalItemsForSidebar() {
      try {
        let res = await api.getSideBarItems();
        for (const item of res.data.res) {
          // item.smi_image = await this.getItemImageUrl(item); //icons disabled for now
          this.additionalElements.push(item);
        }
      } catch (error) {
        // this.handleError(error)
      }
      if(this.notifications.length > 0){
        this.openMenu.notifications = true;
      }
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      s[0] = s[0].toUpperCase();
      return s;
    },
    handleChat() {
      this.$emit("toggle-chat", !this.chatOpened);
    },
    handleOpen(val) {
      for (let key of Object.keys(val)) {
        this.openMenu[key] = val[key];
      }
    },
    toggleSearchBar() {
      this.mobileSearchBar = !this.mobileSearchBar;
    },
    handleShowProfile() {
      this.showProfile = !this.showProfile;
    },
    closeProfile() {
      this.showProfile = false;
    },
    async getFloors() {
      let res = await api.getFloorsElements();
      this.expoFloors = res.data.res.map((el) => {
        let obj = {
          name: el.loc_name,
          loc_id: el.loc_id,
        };
        return obj;
      });
    },
    async getConferences() {
      let res = await api.getConferencesElements();
      let confs = res.data.res;

      for (const conf of confs) {
        for (const index in conf) {
          if (
            conf[index].type === "screen" &&
            conf[index].ltp_code === "conf"
          ) {
            let obj = {
              index: index,
              name: conf[index].loc_name,
              loc_id: conf[index].loc_id,
            };
            this.conferences.push(obj);
          }
        }
      }
    },
    openSearchBox() {
      this.searchOpen = !this.searchOpen;
     /*  setTimeout(() => {
        if (this.searchOpen) {
          this.searchOpen = !this.searchOpen;
        }
      }, 15000); */
    },
    toggleCollapsed() {
      this.mobileMenuVisible = true;
    },
    closeMobileMenu() {
      this.mobileMenuVisible = false;
    },
    setActive(event) {
      let activeElements = document.getElementsByClassName("active");
      activeElements.forEach((element) => {
        element.classList.remove("active");
      });
      this.navConference = false;
      this.navExpo = false;
      event.target.classList.add("active");
      this.mobileMenuVisible = false;
    },
    setActiveConference() {
      let activeElements = document.getElementsByClassName("active");
      activeElements.forEach((element) => {
        element.classList.remove("active");
      });
      this.navExpo = false;
      this.navConference = true;
      this.mobileMenuVisible = false;
    },
    setActiveExpo() {
      let activeElements = document.getElementsByClassName("active");
      activeElements.forEach((element) => {
        element.classList.remove("active");
      });
      this.navConference = false;
      this.navExpo = true;
      this.mobileMenuVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap");

@media only screen and (max-width: 600px) {
  .notifications-drawer{
    max-width: 100vw;
    right: 65vw;
    left: unset !important;
  }
}

.notification-title{
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #262626;
  margin: 0;
}

.notification-join{
  background: #4BC076;
  border-radius: 2px;
  border: 0;
}

.active-sessions{
  border:1px solid white;
  padding: 5px;
  border-radius: 4px;
}

.active-sessions.purple{
  border: 1px solid #56158B;
  color: #56158B;
  font-weight: bold;
  width: 45%;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.active-sessions-tab {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff0000;
  display: inline-block;
  margin-right: 5px;
  border: 2px solid white;
  margin-left: 5px;
  animation: blinker 1.5s linear infinite;
}

nav {
  position: fixed;
  top: 0;
  z-index: 16;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  height: 64px; //var(--nav-height);
}
.nav-heading {
  color: #ffffff;
  font-weight: 700;
  margin: 0;
  font-size: 24px;
  line-height: 22px;
  font-family: "Roboto", sans-serif;
}
.middle a:first-child {
  padding-left: 0;
}
.middle a:nth-child(5),
.middle a:nth-child(6) {
  padding-left: 25px;
}
.middle a {
  color: #ffffff;
  font-weight: 500;
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  font-family: "Roboto", sans-serif;
  padding-left: 40px;
}
.navigation-links {
  display: inline-block;
}
.search-icon {
  margin-left: 20px;
  background: transparent;
  color: white;
  border: 0;
}
.search-icon:hover {
  color: #2295d6;
  border-color: #2295d6;
}
.searchBox {
  width: 675px;
}
.loginBtn,
.loginBtn:hover {
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  padding-top: 3px;
  padding-bottom: 4px;
  padding-left: 16px;
  padding-right: 16px;
  border: 1px solid white;
  border-radius: 2px;
  margin-right: 16px;
}
.registerBtn,
.registerBtn:hover {
  color: #001529;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  padding-top: 3px;
  padding-bottom: 4px;
  padding-left: 16px;
  padding-right: 16px;
  background: #ffffff;
  border: 1px solid white;
  border-radius: 2px;
}
.mobile {
  padding-left: 10px;
  padding-right: 10px;
}
.right,
.left,
.icon-wrap {
  position: relative;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.new-messages-notification {
  position: absolute;
  height: 8px;
  width: 8px;
  top: 4px;
  right: 4px;
  border-radius: 50%;
  background-color: #4BC076;
}
$border-color: rgba(185, 35, 35, 0.8);
$border-size: 8px;

.chat-notific {
  animation: pulse 1.2s infinite;
}

.icon-shake {
  animation: shake 1s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 7px #{$border-size * 1} $border-color;
  }
  25% {
    box-shadow: 0 0 7px #{$border-size * 0.5} $border-color;
  }
  50% {
    box-shadow: 0 0 7px #{$border-size * 1.4} $border-color;
  }
  75% {
    box-shadow: 0 0 7px #{$border-size * 0.8} $border-color;
  }
  100% {
    box-shadow: 0 0 7px #{$border-size * 1} $border-color;
  }
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-0.5px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(1px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-2px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(2px, 0, 0);
  }
}
.avatar-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  .frame {
    position: absolute;
  }
  img {
    object-fit: cover;
    cursor: pointer;
  }
}
.icon-wrap {
  margin-right: 10px;
}
.icon {
  position: relative;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 18px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  margin-right: 7px;
  cursor: pointer;
  transition: background 0.2s ease;
  &.selected {
    background: var(--main-color-shade);
  }
}
.button-round {
  img {
    display: inline-block;
    margin-left: 7px;
  }
}
.profile-wrap {
  position: relative;
  display: flex;
}
.profile-wrap a {
  display: flex;
}
.member-name {
  color: #ffffff;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  font-family: "Roboto", sans-serif;
  margin: 0;
  padding: 5px 0 5px 16px;
}
.triangle {
  width: 0;
  height: 0;
  border-right: 27px solid transparent;
  border-left: 27px solid transparent;
  border-bottom: 25px solid var(--main-color-highlight);
  z-index: 999;
}
.menu-wrap {
  position: absolute;
  top: 35px;
  left: -10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  z-index: 999;
  width: 100%;
}

.items-container {
  background: var(--main-color-highlight);
  border-radius: 7px;
  position: relative;
  top: -5px;
  left: -13px;
  z-index: 999;
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  a {
    cursor: pointer;
    display: block;
    white-space: nowrap;
    margin: 5px 0;
  }
  &.login-container a:last-child {
    color: #b92323;
  }
  border: 2px solid var(--main-color-highlight);
}
.login-container {
  left: -20px;
  width: 100px;
}

.notifications-drawer {
  width: 420px;
  left: -350px;
}

.items {
  background: var(--main-color);
  padding: 15px;
}

.notification-item {
  z-index: 1000;
  position: relative;
  white-space: break-spaces !important;
  line-break: auto;
}

.notification-item.no-hairline::after {
  display: none;
}

.notification-item::after {
  position: absolute;
  bottom: -5px;
  content: "";
  width: 80%;
  height: 1px;
  background-color: #bdbdbd;
  left: 10%;
  z-index: 999;
}

.popup-menu-heading {
  border-radius: 7px;
  height: 42px;
  padding: 15px;
  background: var(--main-color-shade);
  width: calc(100% - 30px);
}
.call {
  animation: "call-animation" 0.75s linear infinite;
}
.new-call-wrap {
  position: absolute;
  top: 170%;
  width: 180px;
  background: var(--button-color-green);
  padding: 10px;
  text-align: center;
  color: white;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  user-select: none;
  &.mobile {
    right: 0;
  }
}
</style>
